import { render, staticRenderFns } from "./winBar.vue?vue&type=template&id=25f48b11&scoped=true&"
import script from "./winBar.vue?vue&type=script&lang=ts&"
export * from "./winBar.vue?vue&type=script&lang=ts&"
import style0 from "./winBar.vue?vue&type=style&index=0&id=25f48b11&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f48b11",
  null
  
)

export default component.exports